import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, PaletteIcon, CheckCircleIcon } from 'lucide-react';
const FEATURES = [{
  icon: BookOpenIcon,
  title: 'Historia completa y en orden',
  text: 'De la Creación al Apocalipsis, entiende el hilo completo de la Biblia.'
}, {
  icon: PaletteIcon,
  title: 'Arte estilo novela gráfica',
  text: 'Ilustraciones vibrantes que capturan la imaginación.'
}, {
  icon: CheckCircleIcon,
  title: 'Fiel a la Escritura',
  text: 'Cada relato indica el pasaje bíblico en que se basa.'
}];
export function SolutionSection() {
  return <section className="w-full bg-cream" data-id="element-159" data-mp="atcnj7jct5sx">
      <div className="mx-auto max-w-6xl px-4 py-5 md:py-6" data-id="element-160" data-mp="aw8jiqbn5keq">
        <div className="grid grid-cols-1 items-center gap-6 md:grid-cols-2" data-id="element-161" data-mp="5wm3ya8cbs2r">
          <motion.img initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} src="https://cdn.magicpatterns.com/patterns/generated-images/737e524b-173f-4ead-ab6e-e8ad833a2a4f.jpg" alt="Páginas interiores de La Biblia en Cómic abiertas en abanico" width={1024} height={1024} loading="lazy" decoding="async" sizes="(min-width: 768px) 560px, 100vw" className="h-auto w-full rounded-card shadow-soft" data-id="element-162" data-mp="krsdv8ak4b1d" />

          <div data-id="element-163" data-mp="3p8osbz12qr0p">
            <h2 className="font-display text-3xl font-bold leading-tight text-deep-blue md:text-[38px]" data-id="element-164" data-mp="3p984ez41ml6t">
              La misma Palabra de siempre. Contada como una{' '}
              <span className="mark-gold" data-id="element-165" data-mp="2uyiqxrhzr9q">épica</span> que no van a poder soltar.
            </h2>
            <p className="mt-4 text-[17px] font-medium text-ink/90" data-id="element-166" data-mp="6ufn1nv6uidb">
              El resultado, según cientos de padres que ya probaron el formato:
              niños que la leen de principio a fin por voluntad propia... y
              después la vuelven a empezar.
            </p>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-3" data-id="element-167" data-mp="2cxclozrvcdhe">
          {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return <motion.div key={f.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="text-center" data-id="element-168" data-mp="2mn4kk6703sro" data-mpi={i}>
                <span className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-deep-blue/5" data-id="element-169" data-mp="2rknxn2rypzi1">
                  <Icon className="h-7 w-7 text-deep-blue" aria-hidden="true" data-id="element-170" data-mp="35kyq2a8x7m5b" />
                </span>
                <h3 className="font-display text-lg font-bold text-deep-blue" data-id="element-171" data-mp="30mx5tlzrdgs9">
                  {f.title}
                </h3>
                <p className="mt-1 text-[15px] text-ink/70" data-id="element-172" data-mp="1b9ag6mhjq9rs">{f.text}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}